import type { ConceptId, Lesson } from './schema.js';

const COVER_BY_CONCEPT: Readonly<Partial<Record<ConceptId, string>>> = {
  puzzles: '/lessons/puzzles.webp',
  opening: '/lessons/opening.webp',
  endgame: '/lessons/endgame.webp',
  attack: '/lessons/attack.webp',
  defense: '/lessons/defense.webp',
  development: '/lessons/development.webp',
};

/** Concept-driven cover for a lesson; an explicit lesson.coverImage wins. */
export function lessonCover(lesson: Lesson): string | null {
  if (lesson.coverImage) return lesson.coverImage;
  const first = lesson.concepts.find((c) => COVER_BY_CONCEPT[c]);
  return first ? (COVER_BY_CONCEPT[first] ?? null) : null;
}
